import { useDispatch } from "react-redux";

const useSetDatetime = () => {
  const dispatch = useDispatch();

  const set = (date, time) => {
  };

  return {
    set,
  };
};

export default useSetDatetime;
